import {format, formatISO, endOfDay, toDate, parse} from 'date-fns'
import i18next from 'i18next'
import store from '../redux/Store'
import {top} from "../redux/reducers/messagesSlice";
import {is} from 'date-fns/locale';

const deepCopy = (obj) => {
    return JSON.parse(JSON.stringify(obj))
}

export const kprint = (message = "", data = "") => {
    console.log("KPRINT: " + message + " >> ", data)
}

const view = (value, defaultValue = '-') => {
    return (value && ['null', 'undefined'].includes(value) === false || value === 0) ? value : defaultValue
}


const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
export const CommonHelper = {
    deepCopy, view, numberWithCommas
}

const FORMAT_DATE = 'dd/MM/yyyy'; //'yyyy-MM-dd'
const FORMAT_DATE_TIME = 'dd/MM/yyyy hh:mm a';//'yyyy-MM-dd HH:mm'

const formatISODate = (date, ignoreOffset = true) => {
    try {
        // console.log(date, ignoreOffset)
        if (typeof date === 'string') {
            date = new Date(date)
        }
        date = formatISO(date).replace(/.\d+Z$/g, "Z");
        if (ignoreOffset) {
            date = date.substring(0, 19)
        }
    } catch (e) {
        // console.log(e)
        return '';
    }
    // console.log(date)
    return date;
}

const formatDate = (date, formatString = FORMAT_DATE, ignoreOffset = true) => {
    // console.log(date)
    try {
        if (!date) {
            return '-';
        }
        if (typeof date === 'string') {
            date = new Date(date)
        }
        date = format(date, formatString)
    } catch (e) {
        // console.log(e)
    }
    // console.log(date)
    return date;
}


const parseDate = (date, length = 19) => {
    if (typeof date !== 'string') {
        if (typeof date === 'object') {
            date = date.toLocaleString()
        }
    }
    return date.substring(0, length)
}

const _parse = (date, format) => {
    return parse(date, format, new Date())
}

const _endOfDay = (date) => {
    try {
        // console.log(date, new Date(date), endOfDay(new Date(date)))
        return formatISODate(endOfDay(new Date(date)));
    } catch (e) {
        console.log(e)
    }
}

const _toDate = (date) => {
    try {
        return toDate(date)
    } catch (e) {
        // console.log(e)
        return date;
    }
}

const _isAfter = (date1, date2) => {
    try {
        // console.log(date1, date2)
        return (new Date(date1).getTime() > new Date(date2).getTime())
    } catch (e) {
        // console.log(e);
        throw e;
    }
}


export const DateHelper = {
    parseDate,
    formatDate,
    formatISODate,
    endOfDay: _endOfDay,
    FORMAT_DATE,
    FORMAT_DATE_TIME,
    isAfter: _isAfter,
    toDate: _toDate,
    parse: _parse
}

const messageBuilder = (t, message, data) => {
    const msg = t(`msg.${message}`)
    Object.keys(data).map(key => {
        msg.replace(key, t(`lbl.${data[key]}`))
    })
    return message
}

export const MessageHelper = {messageBuilder}

export const componentLabel = (t, component) => {
    const componentMap = {'multi-channel-integrator': 'kmci', 'fep': 'kfep'}
    return t(`lbl.${componentMap[component]}`)
}

export const t = (localizationMap) => {
    return i18next.t(localizationMap);
}

export const removeStorageAndLogout = () => {
    removeCredential();
    window.location.replace("/login");
}

export const removeCredential = () => {
    let currentLang = sessionStorage.getItem("i18nextLng");
    sessionStorage.clear();
    sessionStorage.setItem("i18nextLng", currentLang);
}

export const getCredential = () => {
    let cred = sessionStorage.getItem("credentials");
    if (cred) {
        return JSON.parse(cred);
    } else return {};
}

export const getUserId = () => {
    let cred = getCredential();
    if (cred.userId) return cred.userId;
    else return 0;
}

export const setCredentials = (credential) => {

    sessionStorage.setItem('_expiredTime', credential.sessionExpiredTimeInMillis + "")

    sessionStorage.setItem('credentials', JSON.stringify(credential));
}

export const showErrorToast = (err) => {
    let message = "";
    let reason = "";
    let status = "";
    if (err?.response?.data?.reason) {
        let errData = err.response.data;
        status = err.response.status;
        // let messageKey = "msg.serverErrorCode." + err.response.data.reason;
        // message = t(messageKey);
        // if (message === messageKey) message = t("msg.somthingWentWrong");
        message = errData.message;
        reason = errData.reason;
    } else {
        message = t("msg.somthingWentWrong");
    }

    store.dispatch(top({
        server:
            {message: message, status: status, errCode: reason, isServerError: true}
    }))
}

export const removeReadOnly = (e) => {
    e.target.removeAttribute("readonly");
}

export const formatCurrencyBangla = (amount) => {
    if (!amount) return "";
    return amount.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',')
}

export const formatCurrencyInternational = (amount) => {
    if (!amount) return "";
    return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export const addReadOnly = (e) => {
    e.target.setAttribute("readonly", "true");
}

export const showToastMessage = (message, status) => {
    store.dispatch(top({
        server: {message: message, status: status}
    }))
}

export const showErrorToastMessage = (message, status, errorCode,) => {
    store.dispatch(top({
        server: {message: message, status: status, errCode: errorCode, isServerError: true}
    }))
}

export const showRequiredField = (fieldName) => {
    let message = t("msg.showRequiredField").replace("<%data%>", fieldName)
    store.dispatch(top({
        server: {message: message, status: 404}
    }))
}

export const showInvalidField = (fieldName) => {
    let message = t("msg.showValidField").replace("<%data%>", fieldName)
    store.dispatch(top({
        server: {message: message, status: 404}
    }))
}

export const isAmount = (valueStr) => {
    if (/^\d+(\.\d{1,2})?$/.test(valueStr)) return true;
}

export const isNumber = (valueStr) => {
    if (/^\d+$/.test(valueStr)) return true;
}

export const isBankAccountNumber = (valueStr) => {
    if (valueStr.length > 9 && valueStr.length < 18) return true;
}

export const isMobileNumber = (valueStr) => {
    // if(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(valueStr)) return true;
    if (valueStr.length > 7 && /^[\d ()+-]+$/.test(valueStr)) return true;
}

export const getUserName = () => {
    let cred = getCredential();
    if (cred.name) return cred.name;
    else return "";
}

export const getUserEmail = () => {
    let cred = getCredential();
    if (cred.username) return cred.username;
    else return "";
}
export const storeOwnAccountList = (accountList) => {
    sessionStorage.setItem("myAccountList", JSON.stringify(accountList));
}

export const getOwnAccountList = () => {
    let myAccountListStr = sessionStorage.getItem("myAccountList");
    return myAccountListStr ? JSON.parse(myAccountListStr) : {}

}

export const storeAccountInfo = (info) => {
    sessionStorage.setItem("accountInfo", JSON.stringify(info));
}

export const getAccountInfo = () => {
    let accountInfoStr = sessionStorage.getItem("accountInfo");
    let accountInfo = accountInfoStr ? JSON.parse(accountInfoStr) : {};
    return accountInfo;
}

export const getLanguage = () => {
    return sessionStorage.getItem("i18nextLng");
}

export const alphabeticSort = (arr, property, isDesc) => {
    arr.sort((a, b) => {
        let item1 = a[property];
        let item2 = b[property];
        let flag = 0;

        if (item1 < item2) {
            flag = -1
        } else if (item1 > item2) {
            flag = 1
        }
        if (isDesc) flag = -flag;
        return flag;
    })
    return arr;
}

export const isValidPin = (pin) => {
    return /^[0-9]{6}$/.test(pin);
}

export const isPositiveAmount = (number) => {
    if (isAmount(number)) {
        if (parseFloat(number) > 0) return true;
    }
    return false;
}


export const copyByValue = (obj) => {
    return JSON.parse(JSON.stringify(obj));
}
